import { render } from "./Finalize.vue?vue&type=template&id=20f7be9b"
import script from "./Finalize.vue?vue&type=script&lang=js"
export * from "./Finalize.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/auth/Finalize.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20f7be9b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20f7be9b', __exports__)) {
    api.reload('20f7be9b', __exports__)
  }
  
  module.hot.accept("./Finalize.vue?vue&type=template&id=20f7be9b", () => {
    api.rerender('20f7be9b', render)
  })

}


export default __exports__